import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { colors } from "@material-ui/core"
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import moment from 'moment'

const useStyles = makeStyles(theme => ({
    value: {
        fontSize: 15,
        fontWeight: 500,
        color: colors.grey[900],
    },
    title: {
        fontSize: 12,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
      },
}));

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export const Comment = ({ comment, dateCreated, reviewer, reviewDate }) => {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const bull = <span className={classes.bullet}>•</span>;

    return (
        <div>
            <Button variant="contained" color="primary" onClick={handleClickOpen}>
                Click to View Comment
      </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Comment
        </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span className={classes.value}><li>{comment}</li></span><br />
                        <Typography className={classes.title} color="textSecondary" >
                        {bull}Date Submitted&nbsp;-&nbsp;{moment(dateCreated).format('MMMM Do YYYY')}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                        {bull}Date Approved&nbsp;-&nbsp;{moment(reviewDate).format('MMMM Do YYYY')}<br/>
                        {bull}Approved By&nbsp;-&nbsp;{reviewer}&nbsp;
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {/* <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button> */}
                    <Button onClick={handleClose} color="primary">
                        Close
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Comment;